import { combineReducers } from 'redux';
import undoable from 'redux-undo';
import { INVALIDATE as AUTH_INVALIDATE } from '@/store/actions/auth';
import { LOAD, CHANGE_ROUTE_TYPE } from '@/store/actions/edit_ride/ride';
import { types as WAYPOINT_TYPES } from '@/store/actions/edit_ride/waypoints';
import {
    UNDO,
    REDO,
    RESET_CACHE,
    RESTORE_STATE
} from '@/store/actions/edit_ride';

import cacheReducer from '@/store/reducers/edit_ride/cache';
import metaReducer from '@/store/reducers/edit_ride/meta';
import rideReducer from '@/store/reducers/edit_ride/ride';
import routesReducer from '@/store/reducers/edit_ride/routes';

const reducer = combineReducers({
    cache: cacheReducer,
    meta: metaReducer,
    ride: rideReducer,
    routes: routesReducer
});

const UNDOABLE_TYPES = [...WAYPOINT_TYPES, LOAD, CHANGE_ROUTE_TYPE];

const undoableReducer = undoable(reducer, {
    filter: (action) =>
        UNDOABLE_TYPES.includes(action.type) &&
        action.undoable !== false &&
        (!action.data.edits || typeof action.data.edits.name === 'undefined'),
    undoType: UNDO,
    redoType: REDO,
    ignoreInitialState: true
});

export default (state, action) => {
    switch (action.type) {
        case AUTH_INVALIDATE: {
            return state.present.ride.privacy === 'PRIVATE' &&
                state.present.ride.id !== undefined
                ? undoableReducer(undefined, action)
                : state;
        }

        case RESET_CACHE: {
            return {
                ...state,
                _latestUnfiltered: null,
                past: []
            };
        }

        case RESTORE_STATE: {
            return action.data;
        }

        default: {
            return undoableReducer(state, action);
        }
    }
};
